export enum SearchResultViewType {
  CONTENT_LIST = 'content-list',
  GALLERY = 'gallery',
  LIST = 'list',
  LIST_THUMBNAIL = 'list-thumbnail',
  SELECTOR = 'selector',
  THUMBNAIL = 'thumbnail',
}
